module.exports = {
  title: '东坡智慧党建云平台',
  version: require('../package.json').version
}
